/**
 * IMPORTS
 */

import { Button } from "@components/button/button";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

interface ModalConfirmacaoProps {
  isPending: boolean;
  onCancel: () => void;
  confirmarSolicitacao: () => void;
}
export function ModalConfirmacaoRemessa({
  isPending,
  onCancel,
  confirmarSolicitacao,
}: ModalConfirmacaoProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="w-[400px] space-y-5 rounded-xl bg-white p-6 shadow-xl">
        <h3 className="text-lg font-semibold text-zinc-800">Confirmar solicitação da remessa?</h3>
        <p className="text-sm text-zinc-600">
          Deseja realmente está liberando a remessa do Cliente?
        </p>

        <div className="flex justify-end gap-3">
          <Button
            type="button"
            className="bg-zinc-300 text-zinc-800 hover:bg-zinc-400"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button disabled={false} type="button" onClick={confirmarSolicitacao}>
            {isPending ? <SpinnerSimple /> : "Solicitar remessa"}
          </Button>
        </div>
      </div>
    </div>
  );
}
